module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/vi/4-2f797fe4f120edba97e1b1489abd8eff.jpg";